<template>
  <div>
    <div class="grid bg-white" v-if="!isReadOnlyUser">
      <div class="grid-title">
        <h1 class="float-left">Create Certificate</h1>
      </div>
      <div class="grid-body">
        <div class="row">
          <form @submit.prevent="createCertificate()">
            <div class="col-md-12">
              <input
                type="text"
                v-model="barcode"
                class="form-control scan-shirt"
              />
            </div>
            <div class="col-md-12">
              <br />
              <button type="submit" class="btn btn-lg btn-block btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="grid-body">
        <h1 class="text-bold message">{{ message }}</h1>
        <br /><br />
      </div>
    </div>
    <div class="grid bg-white" v-else>
      <div class="grid-body">
        <h4>
          You don't have the privilege to do this action, please contact an
          administrator.
        </h4>
      </div>
    </div>
    <div class="alert alert-danger" role="alert" v-if="!isReadOnlyUser">
      <strong
        >Note : Please Disable Popup Blocker or allow Popup Window in Your
        Browser !</strong
      >
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isReadOnlyUser: false,
      barcode: null,
      message: null,
      specialRequest: {
        confirmToScan: 0,
      }
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    $(".scan-shirt").focus();
  },
  methods: {
    async createCertificate() {
      this.message = this.barcode;
      $(".loading").show();
      try {
        let res = await axios({
          url: "shirt_orders/create/certificate/" + this.barcode,
          method: "GET",
          responseType: "blob", // important
          params: {
            confirm_to_scan_for_special_request: this.specialRequest.confirmToScan
          }
        });
        if (res) {
          this.barcode = null;
          var url = URL.createObjectURL(res.data);
          window.open(url, "_blank");
          $(".loading").hide();
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else if (error.response.status === 422) {
          Swal.fire({
            title: "Has the special request for this shirt been completed?",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No"
          }).then((result) => {
            if (result.value) {
              this.specialRequest.confirmToScan = 1;
              this.createCertificate();
              this.specialRequest.confirmToScan = 0;
            }
          });
        }
        else {
          toastr.error("Something Went Wrong ! please Try Again");
        }
        $(".loading").hide();
      }
    },
  },
};
</script>

<style scoped>
.scan-shirt {
  font-size: 90px !important;
  height: 200px;
}
.btn-lg {
  height: 50px;
  font-size: 25px;
}
.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
}
.message {
  font-size: 90px;
}
</style>
